import {mapStockFacts} from '../sm-stock-summary/stock-summary.model';
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject} from '@angular/core';
import {map, Observable} from 'rxjs';
import {ItemsService} from '../../../items/items.service';
import {itemGalleryUrls} from '../sm-photo-gallery/item-gallery-urls';
import {SmContextMenuItemModel} from '../sm-context-menu-item/sm-context-menu-item.component';
import {GlobalSearchItemResult} from '../../search/global-search.service';
import {formatSearchResultPath} from '../../search/search-result-path';
import {SmItemListItemModel} from '../sm-item-list-item/sm-item-list-item.component';

@Component({
  selector: 'sm-global-search-item-result',
  templateUrl: './sm-global-search-item-result.component.html',
  styleUrls: ['./sm-global-search-item-result.component.scss'],
  standalone: false,
})
export class SmGlobalSearchItemResultComponent implements OnChanges {
  private readonly itemsService = inject(ItemsService);
  loadGalleryImages: (() => Observable<string[]>) | null = null;
  @Input({required: true}) result!: GlobalSearchItemResult;
  @Input() menuItems: SmContextMenuItemModel[] = [];
  @Input() menuAriaLabelTemplate = '';
  @Input() emptyDescriptionLabel = '';
  @Input() searchQuery = '';
  @Input() openLabelTemplate = '';

  @Output() open = new EventEmitter<GlobalSearchItemResult>();
  @Output() menuItemSelect = new EventEmitter<SmContextMenuItemModel>();

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['result']) return;
    const {locationId, id} = this.result;
    this.loadGalleryImages = () => this.itemsService.getItem(locationId, id).pipe(
      map(item => itemGalleryUrls(item.images)),
    );
  }

  get item(): SmItemListItemModel {
    return {
      id: this.result.id,
      name: this.result.name,
      description: this.result.description,
      imageUrl: this.result.imageUrl,
      ...mapStockFacts(this.result),
      quantity: this.result.quantity,
      unitLabel: this.result.unitLabel,
      contextPathText: this.locationText,
      contextIconName: 'location-outline',
      contextAriaLabel: this.formatTemplate(this.openLabelTemplate, {
        name: this.result.name,
        containerName: this.locationText,
      }) || this.locationText,
    };
  }

  get locationText(): string {
    return formatSearchResultPath(this.result.containerPath) || this.result.containerName.trim();
  }

  get menuAriaLabel(): string {
    return this.formatTemplate(this.menuAriaLabelTemplate, {
      name: this.result.name,
      containerName: this.result.containerName,
    }) || this.result.name;
  }

  handleOpen(): void {
    this.open.emit(this.result);
  }

  handleMenuItemSelect(item: SmContextMenuItemModel): void {
    this.menuItemSelect.emit(item);
  }

  formatTemplate(template: string, values: Record<string, string>): string {
    if (!template.trim()) {
      return '';
    }

    return Object.entries(values).reduce(
      (current, [key, value]) => current.split(`{{${key}}}`).join(value),
      template,
    );
  }
}
